define('taoQtiItem/qtiXmlRenderer/renderers/interactions/SliderInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/interactions/blockInteraction'], function(tpl){
    return {
        qtiClass : 'sliderInteraction',
        template : tpl
    };
});
